import { service } from "@ember/service";
import Controller from "@ember/controller";
import { task } from "ember-concurrency";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class OrganizationSettingsController extends Controller {
  @service ajax;
  @service store;

  get organization() {
    return this.model.organization;
  }

  saveDetailsTask = task(async (properties) => {
    let organization = this.organization;
    organization.setProperties(properties);

    await this.store
      .request(saveRecord(organization))
      .then(() => {})
      .catch((error) => {
        organization.rollbackAttributes();
        throw error;
      });
  });
}
